export const firebaseConfig = {
    apiKey: 'AIzaSyBDRTOD9tqbj_o07Z-xkBSFbqSPUzxTdp8',
    authDomain: 'greenline-b62e9.firebaseapp.com',
    projectId: 'greenline-b62e9',
    storageBucket: 'greenline-b62e9.appspot.com',
    messagingSenderId: '721581754887',
    appId: '1:721581754887:web:372677802dea351e4c38a2',
    measurementId: 'G-YMXQJ2YF79',
};
